import { render, staticRenderFns } from "./PreturiVopsit.vue?vue&type=template&id=0c8878a0&scoped=true"
import script from "./PreturiVopsit.vue?vue&type=script&lang=js"
export * from "./PreturiVopsit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8878a0",
  null
  
)

export default component.exports